<script>
  import productsJson from "./product.js";
  import Pagelayout from "./Views/PageLayout.svelte";
  import { onMount } from "svelte";

  let title = "";
  let price = "";
  let description = "";
  let products = [];
  let cartItems = [];
  let customer = {
    name: "",
    email: "",
    phone: "",
    paymentMethod: null,
    picpay_username: ""
  };

  function setTitle(event) {
    title = event.target.value;
  }

  function addToCart(event) {
    const title = event.detail;

    const exists = cartItems.reduce((sum, curValue) => {
      return curValue.name === title;
    }, 0);
    if (exists) {
      return false;
    }

    cartItems = cartItems.concat({
      ...products.find(prod => prod.name === title)
    });
    window.scrollTo(0, 0);
  }

  function clearCart() {
    cartItems = [];
  }

  onMount(() => {
    products = productsJson;
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" />
  <link
    href="https://stackpath.bootstrapcdn.com/bootswatch/4.4.1/lux/bootstrap.min.css"
    rel="stylesheet"
    integrity="sha384-oOs/gFavzADqv3i5nCM+9CzXe3e5vXLXZ5LZ7PplpsWpTCufB7kqkTlC9FtZ5nJo"
    crossorigin="anonymous" />
  <style type="text/css">
    body {
      padding: 0px;
    }
  </style>
</svelte:head>

<Pagelayout
  bind:customer
  {cartItems}
  {products}
  on:clearCart={clearCart}
  on:addCart={addToCart} />
